import React from 'react'
import Slider from './Slider'

function Home() {
  return (
    <div>
    <Slider/>
    
    </div>
  )
}

export default Home
